import { ComponentsOverrides, Theme } from "@mui/material";

type MuiFormHelperText = {
  styleOverrides: ComponentsOverrides<Theme>["MuiFormHelperText"];
};

const muiInputLabel: MuiFormHelperText = {
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      ...(ownerState.variant === "filled" && {
        color: `${theme.palette.text.secondary}`,
        margin: "7px 0 0",
        lineHeight: 1.66,
      }),
    }),
  },
};

export default muiInputLabel;
